import { Component, OnInit, ElementRef, AfterContentInit, AfterViewInit, OnChanges, DoCheck , Inject, OnDestroy } from '@angular/core';
import { DwComponent, DwComponentType, DwContainerOptions, DwSecurityUserService, DwSectionBaseComponent, DwMetaDataGridActionState,
         DwDateTimeInputOptions, DwOrmDataServiceToken, DwOrmDataService, DwMetaDataFormStateService, DwGridDeleteActionService,
         DwMetaDataFormApi, DwEventService, DwMdEventService, DwGridEvent, DwEvent, DwMdLoadEventData, DwFormContextMode, DwMetaDataServiceToken,
         DwMdQueryEventData, DwMetaDataFilters , DwMetaDataFilter, DwMetaDataService, DwInMemoryDataSource, DwMetaDataGridPreferences,
         DwGridActionResult } 
          from '@devwareapps/devware-cap';
import { AccidentsMetaDataItemNames, WageExpenseEntity, WorkplaceAccidentMetaData, WorkplaceAccidentEntity } 
          from '../../meta-data/accidents-meta-data.service';
import { DwGridRefreshEventData } from '@devwareapps/devware-cap/devware-ui-metadata/grid/model/events/dw-grid-refresh-event-data.model.d';
import { WachterUserExt } from '../../../../shared/models/wachter-user.model';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import * as moment_ from 'moment';
import { Observable, Subscription, of } from 'rxjs';
const moment = moment_;

@DwComponent(
  {
    key: 'workers-comp-wage-grid',
    name: 'Workers Comp Wage Expense Grid',
    componentType: DwComponentType.pageComponent,
    isGlobal: true,
  }
)
@Component({
  selector: 'app-workers-comp-wage-grid',
  template: `
<div class="wc-containerClass">
    <dw-container [options]="containerOptions">
        <span header class="wc-header">
            <strong>Wage Expense Tracker</strong>
        </span>
        <div body>
            <dw-meta-data-grid *ngIf="addMode" [item]="item" [filters]="filterGroup" [dataSource]="dataSource" dataOptions="dataOptions"
                               configKeyPart="wage-workers-comp-add" [preferences]="gridPref"></dw-meta-data-grid>
            <dw-meta-data-grid *ngIf="!addMode" [item]="item" [filters]="filterGroup" [dataSource]="dataSource" dataOptions="dataOptions"
                               configKeyPart="wage-workers-comp" [preferences]="gridPref"></dw-meta-data-grid>
        </div>
    </dw-container>
    <span class="wc-total"><span class="wc-total-lbl">Sum of Paid Wages:</span><span class="dw-tag"><i class="fad fa-usd-circle"></i>&nbsp;{{Sum|number:'.2-2'}}</span></span>
    <div dwRow>
        <div dwCol="1">
            <button [hidden]="Id >= 0" type="button" (click)="add()" class="btn-sm btn-success wc-btn" title=""><i class="fad fa-plus-circle"></i>&nbsp;Add</button>
        </div>
        <div dwCol="3" [hidden]="Id == undefined">
            <label class="label">Date of Paid Wages
              <span *ngIf="Date === undefined || Date == ''" title="Required" class="required-label">&nbsp;*</span>
            </label>
            <dw-date2 *ngIf="Id != undefined" [(ngModel)]="Date" [dateOptions]="dateOptions"></dw-date2>
        </div>
        <div dwCol="4" [hidden]="Id == undefined">
            <label class="label">Wage Details
              <span *ngIf="Details === undefined || Details == ''" title="Required" class="required-label">&nbsp;*</span>
            </label>
            <input type="text" [(ngModel)]="Details" class="form-control">
        </div>
        <div dwCol="2" [hidden]="Id == undefined">
            <label class="label wc-shift-right-lbl">Wages Paid
              <span *ngIf="Amount === undefined || Amount == ''" title="Required" class="required-label">&nbsp;*</span>
            </label>
            <div class="input-group">
                <div class="input-group-prepend"><span prefix="" class="input-group-text" style="font-weight:bold">$</span></div>
                <!--<input type="text" (keyup)="cost($event)" [(ngModel)]="Amount" class="form-control">-->

                <input type="text" [dwNumeric] [decimals]="'2'" [(ngModel)]="Amount" class="form-control">
            </div>
        </div>
        <div dwCol="2" [hidden]="Id == undefined" class="wc-btn-shift">
            <button type="button" [disabled]="disableSave()" (click)="save()"class="btn-sm btn-success wc-btn wc-btn-save" title="">{{Label}}</button>&nbsp;
            <button type="button" (click)="cancel()" class="btn-sm btn-success wc-btn wc-btn-cancel" title="">Cancel</button>
        </div>
    </div>
</div>
  `
})
export class WorkersCompWageGridComponent 
  implements OnInit, DoCheck, OnDestroy {

  item = AccidentsMetaDataItemNames.WageExpense;

  containerOptions: DwContainerOptions = {
    styleName: '',
    containerAllowCollapse : false,
    containerCollapseDefault: false,
    useContainerStyling: false,
    showTitle: true,
  };

  EDIT_TOPIC = 'EDIT-WAGE-EXPENSE';
  DELETE_TOPIC = 'DELETE-WAGE-EXPENSE';
  Label: string = 'Save';
  Sum: number = 0;
  formApi: DwMetaDataFormApi;
  Id? : number = undefined;
  Date: any = undefined;
  Details?: string = undefined;
  Amount?: string = undefined;

  dateOptions: DwDateTimeInputOptions = {
    minDate: {
      isToday: false,
    }
  }

  idFilter : DwMetaDataFilter;
  filterGroup: DwMetaDataFilters;
  workplaceAccident : WorkplaceAccidentEntity;
  dataSource: DwInMemoryDataSource = null;
  gridPref?: Partial<DwMetaDataGridPreferences>;

  constructor(private dwSecurityUserService: DwSecurityUserService,
              private dwEventService: DwEventService,
              private dwMdEventService: DwMdEventService,
              private dwGridDeleteActionService : DwGridDeleteActionService,
              @Inject(DwMetaDataServiceToken) private dwMetaDataService : DwMetaDataService,
              @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
              private dwFormStateService: DwMetaDataFormStateService,
              private el: ElementRef) 
  {
    this.formApi = dwFormStateService.state.formApi;
    this.workplaceAccident = this.formApi.getFormData(); 
  }

  subscriptions: Subscription[] = [];
  toSave : WageExpenseEntity[] = [];

  addMode: boolean = false;
  ngOnInit(): void {
    this.addMode = this.dwFormStateService.state.formConfig.formMode == DwFormContextMode.add;
    if (this.addMode) {
      this.dataSource = new DwInMemoryDataSource(this.dwMetaDataService);
      this.dataSource.setupDataSource(this.toSave, this.item);
      this.dataSource.loadItemLookupItemsOnSave = false;
      this.gridPref = { passCurrentDataSource : true };

      this.subscriptions.push(
        this.dwEventService.getEventData<WageExpenseEntity>(this.DELETE_TOPIC).subscribe(data => this.delete(data))
      );
    }

    this.subscriptions.push(
      this.dwEventService.getEventData<WageExpenseEntity>(this.EDIT_TOPIC).subscribe(data => this.edit(data))
    );

    this.filterGroup = { "WorkplaceAccidentId" : { EQUAL: this.workplaceAccident.WorkplaceAccidentId ?? 0 } };

    this.dwFormStateService.stateChanged.subscribe(state => 
      {
        const data = this.formApi.getFormData();
        const saved = state.actionFiring == false && state.actionMessage == null && data.WorkplaceAccidentId > 0;
        if (saved && this.toSave.length > 0)
        {
          this.toSave.forEach(i => 
            {
              i.WageExpenseId = undefined;
              i.WorkplaceAccidentId = data.WorkplaceAccidentId;
              this.dataService.saveEntity(i).subscribe();
            });
          this.toSave = [];
        }
      });

    this.subscriptions.push(
      this.dwMdEventService.getQueryEvents(this.item)
          .subscribe((event: DwMdQueryEventData) => setTimeout(() => this.calcSum(event.results), 5))
    );      
    this.subscriptions.push(
      this.dwEventService.getEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(this.item))
          .subscribe((event: DwEvent) => this.cancel()));      
  }
  ngOnDestroy(): void {
    for(const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
  ngDoCheck(): void{
  }
  add(){
    this.cancel();
    this.Id = 0;
  }
  delete(item : WageExpenseEntity){
    const i = this.toSave.findIndex(i => i.CreatedByDateTime == item.CreatedByDateTime && i.Details == item.Details && i.Wages == item.Wages);
    if (i > -1)
      this.toSave.splice(i, 1);
    this.dataSource.setupDataSource(this.toSave, this.item);
    this.calcSum(this.toSave);
  }  
  cost($event) { 
    const v = $event.target.value.toString();
    const a = v == '' || v == undefined || isNaN(v) ? null : parseFloat(v); 
    $event.target.value = this.digits(a) > 2 ? a.toFixed(2) : 
                          v.endsWith('..') ? v.split('.')[0] + '.' :
                          v.endsWith('.') ? v : 
                          a?.toString() || ''; 
  }
  digits(amt: number) { 
    return amt == null ? 0 : 
           Math.floor(amt) === amt ? 0 : 
           amt.toString().includes('.') ? amt.toString().split(".")[1].length || 0 : 
           0; 
  }

  editing: any;
  edit(item : WageExpenseEntity){
    this.Label = 'Update';
    this.editing = item;
    this.Id = item.WageExpenseId ?? 0;
    this.Date = moment(item.PaidDateTime).format('MM/DD/YYYY');
    this.Details = item.Details;
    this.Amount = item.Wages.toString();
  }
  save() {
    const accident : WorkplaceAccidentEntity = this.formApi.getFormData(); 
    const wage : WageExpenseEntity = { 
      ...this.dataService.createDummyEntity(AccidentsMetaDataItemNames.WageExpense), 
      ...{  WorkplaceAccidentId: accident.WorkplaceAccidentId,
            Details: this.Details,
            PaidDateTime: moment(this.Date).format("MM/DD/YYYY"),
            Wages : parseFloat(this.Amount),
            CreatedByEthos_UserId: this.editing != undefined ? this.editing.CreatedByEthos_UserId : this.currentUserId,
            CreatedByDateTime : this.editing != undefined ? this.editing.CreatedByDateTime :  this.currentDateTime,
            ModifiedByEthos_UserId: this.currentUserId,
            ModifiedByDateTime: this.currentDateTime }
    };
    if (this.Id > 0)
      wage.WageExpenseId = this.Id;
    
      if(this.addMode){
        if (this.editing) this.delete(this.editing);
        this.dataSource.saveItem(wage).subscribe(() => this.calcSum(this.toSave) );
      }
      else
        this.dataService.saveEntity(wage).subscribe(i => this.calcSum(this.toSave));
      this.cancel();
    }
  calcSum(results : WageExpenseEntity[]){
    this.Sum = results.reduce((s,c) => s + (c as WageExpenseEntity).Wages, 0);
    this.formApi.patchFormData({ WageExpenseWachter : this.Sum.toString()});
    this.cancel();
  }
  disableSave(){
    const isReady = this.Date !== undefined && this.Date != '' &&
                    this.Details !== undefined && this.Details != '' &&
                    this.Amount !== undefined && this.Amount != '' &&
                    moment(this.Date, 'MM/DD/YYYY', true).isValid() == true;
    return !isReady;
  }
  cancel(){ 
    this.Label = 'Save';
    this.Id = undefined; 
    this.Details = undefined; 
    this.Amount = undefined; 
    this.Date = undefined; 
    this.editing = undefined;
  }
  private currentDateTime: string = moment().utc().format("MM/DD/YYYY hh:mm A");
  private currentUserId: number = new WachterUserExt(this.dwSecurityUserService.securityContext.ApplicationUser).trustUserId;
}
